<template>
  <div class="login-form float-right">
    <form @submit.prevent="handleSubmit">
      <b-alert
        v-model="errorMessage"
        variant="danger"
        v-show="hasError && errorMessage"
        >{{ errorMessage }}
      </b-alert>
      <div class="d-flex">
        <div class="field-ctnr">
          <div class="form-group">
            <input
              type="email"
              v-model="email"
              name="email"
              class="form-control"
              placeholder="Identifiant"
              :class="{ 'is-invalid': submitted && !email }"
            />

            <div v-show="submitted && !email" class="invalid-feedback">
              Identifiant requis
            </div>
          </div>
          <div class="form-group">
            <input
              type="password"
              v-model="password"
              name="password"
              class="form-control"
              placeholder="Password"
              :class="{ 'is-invalid': submitted && !password }"
            />
            <div v-show="submitted && !password" class="invalid-feedback">
              Mot de passe requis
            </div>
            <div class="forget-password">
              <a
                href="#"
                @click.prevent="handleShowModal"
                title="Mot de passe oublié"
                ><img src="../../assets/icon-mdp.png" alt=""
              /></a>
            </div>
          </div>
        </div>

        <div class="form-group">
          <button class="btn btn-primary">Se connecter</button>
        </div>
      </div>
    </form>

    <b-modal
      title="Récuperation de mot de passe"
      :modal-class="'base-modal'"
      centered
      ref="modal-mot-de-passe"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
      @ok.prevent="handleOk"
    >
      <b-form @submit.prevent="">
        <div class="alert alert-danger" v-show="hasForgetPassError">
          {{ forgetPassErrorMessage }}
        </div>

        <b-form-group id="email_group" label="Email" label-for="email">
          <input
            type="email"
            name="email"
            v-model="email"
            class="form-control"
            v-validate="'required'"
          />
        </b-form-group>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  data () {
    return {
      email: '',
      password: '',
      submitted: false,
      hasError: false,
      errorMessage: '',
      hasForgetPassError: false,
      forgetPassErrorMessage: ''
    }
  },
  methods: {
    ...mapActions(['login', 'storeRole', 'resetPassword']),

    handleSubmit (e) {
      this.submitted = true
      this.errorMessage = ''
      this.hasError = false

      const { email, password } = this
      if (email && password) {
        this.login({ username: email, password })
          .then((resp) => {
            this.$router.push('/dashboard')
          })
          .catch(err => {
            this.hasError = true
            this.errorMessage = err
          })
      }
    },
    handleShowModal () {
      this.$refs['modal-mot-de-passe'].show()
    },
    async handleOk () {
      this.hasForgetPassError = false
      this.forgetPassErrorMessage = ''
      let message = await this.resetPassword({ email: this.email })

      if (message !== 200) {
        this.hasForgetPassError = true
        this.forgetPassErrorMessage = message
        return false
      }

      this.$toaster.success('E-mail envoyé')
      this.$refs['modal-mot-de-passe'].hide()
    }
    /*
    checkPasswordExpression (password) {
      const regexp = new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})')
      return regexp.test(password)
    } */
  }
}
</script>

<style lang="scss">
.field-ctnr {
  margin-right: 15px;
  position: relative;
}
.login-form {
  font-family: "Noto Sans", sans-serif;
  padding: 30px;
  h2 {
    text-transform: uppercase;
    font-size: 20px;
    color: #236aa3;
    font-weight: 600;
    text-align: center;
    margin-top: 0;
    margin-bottom: 30px;
  }
  .form-group {
    margin-bottom: 5px;
    input {
      background-color: transparent;
      color: #fff;
      font-size: 15px;
      height: 25px;
      line-height: 25px;
      padding-top: 0;
      padding-bottom: 0;
      font-family: "Noto Sans", sans-serif;
      border-color: #fff;
      border-radius: 3px;
    }
    input:-webkit-autofill,
    input:-webkit-autofill:hover,
    input:-webkit-autofill:focus {
      -webkit-box-shadow: 0 0 0 30px #2b3085 inset !important;
      -webkit-text-fill-color: #fff !important;
    }
    ::placeholder {
      color: #fff;
    }
  }
  .forget-password {
    position: absolute;
    left: -35px;
    margin-top: -25px;
  }
  .btn-primary {
    background-color: #fff;
    color: #2b3085;
    height: 25px;
    line-height: 24px;
    font-size: 15px;
    padding-top: 0;
    padding-bottom: 5px;
    font-weight: 400;
    font-family: "Noto Sans", sans-serif;
    border-radius: 0;
    vertical-align: top;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/login/LoginForm.vue